import HTML_ICON from "../../assets/html.svg";
import CSS3_ICON from "../../assets/css.svg";
import JAVASCRIPT_ICON from "../../assets/javascript.svg";
import TYPESCRIPT_ICON from "../../assets/typescript.svg";
import MONGODB_ICON from "../../assets/mongodb.png";
import REACT_ICON from "../../assets/react.svg";
import NEXT_ICON from "../../assets/nextjs.svg";
import TAILWIND_ICON from "../../assets/tailwind.png";
import FIREBASE_ICON from "../../assets/firebase.svg";
import GSAP_ICON from "../../assets/gsap.svg";

export const technicalSkills = [
  {
    id: 1,
    img: HTML_ICON,
    name: "html",
  },
  {
    id: 2,
    img: CSS3_ICON,
    name: "css",
  },
  {
    id: 3,
    img: JAVASCRIPT_ICON,
    name: "js",
  },
  {
    id: 4,
    img: TYPESCRIPT_ICON,
    name: "ts",
  },
  {
    id: 5,
    img: REACT_ICON,
    name: "react",
  },
  {
    id: 6,
    img: NEXT_ICON,
    name: "NextJs",
  },
  {
    id: 7,
    img: MONGODB_ICON,
    name: "mongodb",
  },
  {
    id: 8,
    img: FIREBASE_ICON,
    name: "firebase",
  },
  {
    id: 9,
    img: GSAP_ICON,
    name: "gsap",
  },
  {
    id: 10,
    img: TAILWIND_ICON,
    name: "tailwind",
  },
];

export const softSkills = [
  "Good Communication Skills",
  "Critical Thinking & Problem Solving",
  "Team Work & Collaboration",
  "Professionalism & Strong Work Ethics",
  "Flexibility & Adaptability",
  "Time Management Skills",
];
